import { Manager } from './src/Manager';
export { RedirectError, RedirectLimitError } from './src/common';
export { Loader } from './src/Loader';
export * from './src/sanitizers';
export { default as Scope } from './src/Scope';
export function installRouteLoader(router, options) {
    const mgr = new Manager(options);
    return mgr.install(router);
}
